'use strict';

// Mini cart Includes
var base = require('wishlists/components/miniCart');

// Cart Includes
var cart = require('../cart/cart');

// Constants
var HTML_CLASS = {
    CART: 'cart'
};
var SELECTOR = {
    MINICART: '.minicart',
    PAGE: {
        CART: '.page[data-action="Cart-Show"]'
    },
    POPOVER: '.minicart .popover'
};

// Variables
var updateMiniCart = true;
var location = window.location;

/**
 * Close the minicart popover and ensure any open select2 quantity dropdown is closed.
 * The quantity <select> in productCardQuantitySelector.isml has class .quantity and uses
 * dropdownParent=".popover .container.cart", so the select2 dropdown lives inside the
 * popover DOM. Calling select2('close') resets its open state before the popover hides.
 */
function closeMinicartPopover() {
    $('.minicart .quantity').each(function () {
        if ($(this).hasClass('select2-hidden-accessible')) {
            $(this).select2('close');
        }
    });
    $('.minicart .popover').removeClass('show');
}

/**
 * Base cartridge miniCart.js file content.
 * The entire function content is not modified.
 * Changes from base cartridge:
 *      1. execute cart() from app_custom_ptdf cartridge.
 */
function initBase() {
    cart();

    $('.minicart').on('count:update', function (event, count) {
        if (count && $.isNumeric(count.quantityTotal)) {
            $('.minicart .minicart-quantity').text(count.quantityTotal);
            $('.minicart .minicart-link').attr({
                'aria-label': count.minicartCountOfItems,
                title: count.minicartCountOfItems
            });
        }
    });

    $('.minicart').on('mouseenter focusin touchstart', function () {
        if ($('.search:visible').length === 0) {
            return;
        }
        var url = $('.minicart').data('action-url');
        var count = parseInt($('.minicart .minicart-quantity').text(), 10);

        if (count !== 0 && $('.minicart .popover.show').length === 0) {
            if (!updateMiniCart) {
                $('.minicart .popover').addClass('show');
                return;
            }

            $('.minicart .popover').addClass('show');
            $('.minicart .popover').spinner().start();
            $.get(url, function (data) {
                $('.minicart .popover').empty();
                $('.minicart .popover').append(data);
                updateMiniCart = false;
                $.spinner().stop();
            });
        }
    });
    $('body').on('touchstart click', function (e) {
        if ($('.minicart').has(e.target).length <= 0) {
            closeMinicartPopover();
        }
    });
    $('.minicart').on('mouseleave focusout', function (event) {
        if (
            (event.type === 'focusout' && $('.minicart').has(event.target).length > 0) ||
            (event.type === 'mouseleave' && $(event.target).is('.minicart .quantity')) ||
            $('body').hasClass('modal-open')
        ) {
            event.stopPropagation();
            return;
        }
        closeMinicartPopover();
    });
    $('body').on('change', '.minicart .quantity', function () {
        if ($(this).parents('.bonus-product-line-item').length && $('.cart-page').length) {
            location.reload();
        }
    });
    $('body').on('product:afterAddToCart', function () {
        updateMiniCart = true;
    });
    $('body').on('cart:update', function () {
        updateMiniCart = true;
    });
    $(window).on('scroll.minicart', function () {
        if ($('.minicart .popover.show').length) {
            closeMinicartPopover();
        }
    });
}

/**
 * Attach a Mutation Observer to the minicart container, that will be triggered
 * when new cart content is attached to the DOM.
 */
function onMinicartShow() {
    // Constants
    const $POPOVER = $(SELECTOR.POPOVER);

    // 1. Define mutation observer
    var observer = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
            const ADDED_NODES = mutation.addedNodes;

            if (ADDED_NODES.length > 0 && $(ADDED_NODES).hasClass(HTML_CLASS.CART)) {
                $('body').trigger('com:initSelects');
            }
        });
    });

    // 2. Attach mutation observer
    $POPOVER.each(function () {
        observer.observe(this, {
            childList: true
        });
    });
}

/**
 * Remove the following minicart event listeners:
 *  - mouseenter focusin touchstart: Remove every listener attach to these events only on cart page.
 */
function detachEventListeners() {
    if ($(SELECTOR.PAGE.CART).length) {
        $(SELECTOR.MINICART).off();
    }
}

/**
 * Expose functions
 */
base.base = initBase;
base.onMinicartShow = onMinicartShow;
base.detachEventListeners = detachEventListeners;

module.exports = base;
